import React, { FunctionComponent } from 'react';
import { Flex } from 'rebass/styled-components';
import { useAppState } from '../../hooks';
import { InfoCard, ButtonLink } from '..';
import { InfoContent } from '../card';

const copyText = require('./copy-text.json');

const {
  AUTH_INFO_HEADER, TOKEN_EXPIRY_NOTICE, TOKEN_EXPIRY_NOTICE_DETAIL,
  CCS_V2_AUTH_DOCUMENTATION_LINK, AUTH_INFO_CCS_V2_UPGRADE_NOTICE,
  AUTH_INFO_CCS_V2_UPGRADE_NOTICE_DETAIL, AUTH_INFO_CCS_V2_NOTICE,
  AUTH_INFO_CCS_V2_NOTICE_DETAIL,
} = copyText;

const expiryNotice: InfoContent = {
  infoHeader: TOKEN_EXPIRY_NOTICE,
  infoContent: TOKEN_EXPIRY_NOTICE_DETAIL,
};

const upgradeNotice: InfoContent = {
  infoHeader: AUTH_INFO_CCS_V2_UPGRADE_NOTICE,
  infoContent: AUTH_INFO_CCS_V2_UPGRADE_NOTICE_DETAIL,
};

const v2Notice: InfoContent = {
  infoHeader: AUTH_INFO_CCS_V2_NOTICE,
  infoContent: AUTH_INFO_CCS_V2_NOTICE_DETAIL,
};

const AuthInfoCard: FunctionComponent<{}> = () => {
  const { features } = useAppState();

  const isMigratedFromV1 = !!features?.['maven.feature.isMigratedCcsV2'];

  const content: Array<InfoContent> = isMigratedFromV1 ? [
    upgradeNotice,
  ] : [
    v2Notice,
  ];

  return (
    <InfoCard
      header={AUTH_INFO_HEADER}
      content={content}
      footer={(
        <Flex justifyContent="center">
          <ButtonLink variant="inlineLink" link={CCS_V2_AUTH_DOCUMENTATION_LINK}>View Documentation</ButtonLink>
        </Flex>
      )}
    />
  );
};

export default AuthInfoCard;
